import { keys as parentKeys } from '@copro/api';

const all = [...parentKeys.all, 'notifications'] as const;

export const keys = {
  all,
  lists: () => [...all, 'lists'] as const,
  list: (spaceId: string, userId: string) => [...keys.lists(), spaceId, userId] as const,
  unreadCount: () => [...all, 'unread-count'] as const,
};
